/**
 * Rutare pe hash — minimul necesar ca URL-ul să reflecte ecranul.
 *
 * Nu e cosmetică. Configuratorul scanează navigând cu `location.href` prin
 * linkurile găsite și citind DOM-ul randat; identitatea unei pagini pentru SDK
 * e `pathname + hash` (`sdk/src/page.ts`). Cât timp sidebar-ul făcea
 * `preventDefault()` și ținea ecranul într-un `useState`, cele patru linkuri
 * `#/…` duceau toate la același DOM: scanul ar fi produs patru pagini identice,
 * toate descriind Overview, iar asistentul n-ar fi putut ști niciodată pe ce
 * ecran se află vizitatorul. Dedup-ul scanului e pe pattern de URL, deci nimic
 * n-ar fi prins duplicarea.
 *
 * Doar ecranele principale au rută. Drawerele și modalele rămân stare locală —
 * la runtime asistentul le vede oricum, fiindcă fiecare întrebare trimite un
 * snapshot al DOM-ului viu.
 */
export type Page = "dashboard" | "pipeline" | "companies" | "billing" | "about";

const PAGES: Page[] = ["dashboard", "pipeline", "companies", "billing", "about"];

export const DEFAULT_PAGE: Page = "dashboard";

export function hashFor(page: Page): string {
  return `#/${page}`;
}

/** Hash necunoscut sau absent => ecranul implicit, niciodată un ecran gol. */
export function pageFromHash(hash: string): Page {
  const slug = hash.replace(/^#\/?/, "");
  return PAGES.includes(slug as Page) ? (slug as Page) : DEFAULT_PAGE;
}

/**
 * `/` și `/#/dashboard` randează același ecran. Fără canonicalizare, scanul le-ar
 * lua drept două pagini distincte și ar plăti un apel LLM pentru fiecare.
 * `replaceState`, nu `location.hash`: nu vrem o intrare în istoric la boot.
 */
export function canonicalizeHash(): void {
  if (location.hash === "") {
    history.replaceState(null, "", location.pathname + location.search + hashFor(DEFAULT_PAGE));
  }
}
